import React from "react";
import { useParams } from "react-router-dom";
import { Redirect } from "react-router-dom";
import topic from "../additional-data/topic";
import tests from "../additional-data/test";
// import answers from '../data/answer';
import Header from "../components/header";

import "./style.css";

import { AdditionalQuiz } from "../components/additional-quiz";

const AdditionalSingleTest = () => {
  let { topicId } = useParams();

  console.log(topicId);

  if (topicId > 13) {
    return <Redirect to={{ pathname: "/404" }} />;
  }
  const topicInfo = topic.find(({ id }) => id === topicId);
  const topicTest = tests.filter((el) => el.topics_id === topicId);

  const topicTestTitle = topicInfo.id + ". " + topicInfo.topics_name;

  // console.log(topicTestTitle);

  return (
    <>
      <Header title={topicTestTitle} />
      <div className="single-test-body">
        <div className="container">
          {/* <a>{topicInfo.id}: {topicInfo.topics_name}</a> */}
          {topicTest.map((el, index) => (
            <AdditionalQuiz
              key={el.id}
              testId={el.id}
              topicId={el.topics_id}
              code={index + 1}
              question={el.questions}
              imageURL={el.images}
              description={el.description}
            />
          ))}
          <div className="no-more">
            <p>Асуулт дууссан</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdditionalSingleTest;
